export function clampSearchNavigationIndex(
  current: number | null,
  resultCount: number,
): number | null {
  if (current === null || resultCount === 0) return null
  return Math.max(0, Math.min(current, resultCount - 1))
}

export function moveSearchNavigationIndex(
  current: number | null,
  resultCount: number,
  direction: -1 | 1,
): number | null {
  if (resultCount === 0) return current
  const bounded = clampSearchNavigationIndex(current, resultCount)
  if (bounded === null) return 0
  if (direction < 0 && bounded === 0) return null
  return Math.max(0, Math.min(resultCount - 1, bounded + direction))
}

export function getSearchEscapeAction(
  query: string,
  hasActiveFilters: boolean,
  remainInSearch = false,
): 'clear-search' | 'open-capture' | 'refocus-search' {
  if (remainInSearch) return 'refocus-search'
  return query.length > 0 || hasActiveFilters ? 'clear-search' : 'open-capture'
}

export function getSettingsCloseFocusTarget(
  mode: 'capture' | 'search',
): 'account' | 'search' {
  return mode === 'search' ? 'search' : 'account'
}

export function shouldKeepBackGuardAfterEscape(
  mode: 'capture' | 'search',
  hasSearchReturn: boolean,
  hasResettableSearch: boolean,
  hasActiveCapture: boolean,
): boolean {
  return (
    hasSearchReturn ||
    (mode === 'search' && hasResettableSearch) ||
    (mode === 'capture' && hasActiveCapture)
  )
}

export type AppBackAction = 'close-note' | 'close-filters' | 'clear-search' | 'open-capture' | 'stay'

/** Browse is the app's main page: Back there goes to a note only when the person stepped from that open note to Browse, else stays. */
export function getAppBackAction(
  mode: 'capture' | 'search',
  filtersOpen: boolean,
  hasResettableSearch: boolean,
  cameFromNote = false,
): AppBackAction {
  if (mode === 'capture') return 'close-note'
  if (filtersOpen) return 'close-filters'
  return hasResettableSearch ? 'clear-search' : cameFromNote ? 'open-capture' : 'stay'
}
